/**
 * WorldReady content namespaces can load lazily. Imperative formatMessage during render
 * throws when the chunk is not ready yet — that bubbles to the app ErrorBoundary and blanks
 * the Venice webview. Prefer this helper for formatMessage calls that run during render on
 * flow entry screens.
 */
type FormatMessageFn = (key: string, vars?: Record<string, unknown>) => string

export function safeFormatMessage(
  formatMessage: FormatMessageFn,
  messageId: string,
  messageOptions: Record<string, unknown> = {},
): string {
  try {
    return formatMessage(messageId, messageOptions) || ''
  } catch {
    return ''
  }
}
